<template>
  <Tree :data="data" :state="state" @open="treeStateOpen" @click="treeStateClick" @hover="treeStateHover" @zoom-item="scrollIntoView" @input="$emit('input', $event)" v-keydown="keyDown" v-if="data">
    <template slot-scope="{ item }">
      <slot :item="item" :on="on(item)" />
    </template>
  </Tree>
</template>

<script>
import Tree from './Tree.vue';
import { defineState } from '../../../libraries/tree';
import { isBetween } from '../../../libraries/common';

export default {
  components: { Tree, },
  props: ['searchWord', 'data', 'loadData'],
  data() {
    return {
      state: {},
    };
  },
  methods: {
    setStateOpen({ item, open }) {
      item.getParents().forEach(f => defineState(this.state, f.stateId, 'opened', true));
      defineState(this.state, item.stateId, 'opened', open);
    },
    treeStateOpen({ item, open }) {
      this.setStateOpen({ item, open });
      this.treeStateHover({ item, hover: true });

      this.$emit('open', item, open);
    },
    treeStateClick(item) {
      Object.keys(this.state).forEach(key => delete this.state[key]);
      [item, ...item.getParents()].forEach(f => defineState(this.state, f.stateId, 'opened', true));
      defineState(this.state, item.stateId, 'clicked', true);
      this.$emit('click', item);
    },
    treeStateHover({ item, hover }) {
      if (hover) {
        Object.keys(this.state)
          .forEach(key => {
            if (this.state[key].hovered)
              this.$set(this.state[key], 'hovered', false);
          });
        defineState(this.state, item.stateId, 'hovered', hover);
      }
    },
    treeStateZoomItem(item) {
      Object.keys(this.state)
        .forEach(key => {
          if (this.state[key].zoomItem)
            this.$set(this.state[key], 'zoomItem', false);
        });
      defineState(this.state, item.stateId, 'zoomItem', true);
    },
    keyDown(event) {
      var currentItem = this.data.find(f => this.state[f.stateId]?.hovered) || this.data;
      if (['ArrowUp', 'ArrowDown'].includes(event.code)) {
        event.preventDefault();
        var getOpened = (acc, item) => {
          acc.add(item);
          if (item === this.data || this.state[item.stateId]?.opened) {
            item.children.forEach(f => getOpened(acc, f));
          }
          return acc;
        }
        var opened = Array.from(getOpened(new Set(), this.data)).tail();
        var newIndex = opened.indexOf(currentItem) + (event.code === 'ArrowUp' ? -1 : 1);
        if (isBetween(newIndex, 0, opened.length - 1)) {
          this.treeStateHover({ item: opened[newIndex], hover: true });
          this.treeStateZoomItem(opened[newIndex]);
        }
      } else if (['ArrowLeft', 'ArrowRight'].includes(event.code)) {
        if (currentItem.item.children !== undefined)
          this.treeStateOpen({ item: currentItem, open: event.code === 'ArrowRight' });
        this.treeStateZoomItem(currentItem);
      } else if (event.code === 'Enter') {
        this.$emit('input', currentItem);
      }
    },
    scrollIntoView(element) {
      var getScrollableParentElement = el => {
        var css = getComputedStyle(el.parentNode);
        if (css.overflowY === 'auto')
          return el.parentNode;
        else
          return getScrollableParentElement(el.parentNode);
      }

      var scrollableEl = getScrollableParentElement(this.$el);
      var scrollBottom = element.offsetTop + element.clientHeight - scrollableEl.clientHeight;
      if (element.offsetTop < scrollableEl.scrollTop) {
        scrollableEl.scrollTo({ top: element.offsetTop })
      } else if (scrollBottom > scrollableEl.scrollTop) {
        scrollableEl.scrollTo({ top: scrollBottom })
      }
    },
    on(item) {
      return {
        click: (event) => {
          event.preventDefault();
          this.$emit('input', item);
        },
        mousedown: (event) => {
          event.preventDefault();
        },
      };
    },
  },
  watch: {
    data: {
      handler() {
        this.data.forEach(f => f.stateId = f.stateId || Math.random());

        var hovered = this.data.find(f => (this.state[f.stateId] || {}).hovered);
        if (!hovered && this.data.children?.first()) {
          this.treeStateHover({ item: this.data.children[0], hover: true });
        }
      },
      deep: true,
      immediate: true,
    },
  }
}
</script>

<style lang="scss" scoped>
</style>